import { put } from 'redux-saga/effects';
import EasyRedux from '../../../utils/EasyRedux';
import handleSagaError from '../../handleSagaError';

const key = 'INVOICE/LIST';

export const { actionTypes, actions, reducer } = new EasyRedux(key);

export function* watchGetInvoiceList(client, { payload: { resolve, reject } }) {
  try {
    const response = yield client.post('merchant/order/list', {
      data: { lm: 20, pg: 1 },
    });
    yield put(actions.loadSuccess(response.result));
    resolve && resolve(response.result);
  } catch (e) {
    reject && reject(e);
    yield put(actions.loadFailure(e));
    yield handleSagaError(e);
  }
}

export default reducer;
